// extracted by mini-css-extract-plugin
export default {"expandedStickyHead":"JobCompany_expandedStickyHead__CM4Lm","expandedHeadMain":"JobCompany_expandedHeadMain__z0g5C","expandedBody":"JobCompany_expandedBody__Oulai"};